import { render, staticRenderFns } from "./PriceListOptions.vue?vue&type=template&id=39a7a032"
import script from "./PriceListOptions.vue?vue&type=script&lang=js"
export * from "./PriceListOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports